module.exports = __webpack_public_path__ + "static/media/wide.ad28a9c3.jpg";